import { createTrackingUtils } from "../index.js";
const utils = createTrackingUtils({
    name: "flights_web_cat_fly_anywhere_map_view_mdot",
    defaultStage: 1,
    stages: {
        main: 1,
        fly_anywhere_list_view: 2,
        fly_anywhere_map_view: 3
    },
    goals: {
        indexBanner: 1,
        exploreCard: 2,
        discoverCarousel: 3,
        markerClick: 4
    }
});
export default utils;
